// extracted by mini-css-extract-plugin
module.exports = {"top_bar":"AbsenceTopBarView_top_bar__2V8he","absence_button":"AbsenceTopBarView_absence_button__CblGH","active":"AbsenceTopBarView_active__1q3YN"};